<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="width">
    <v-card>
      <v-card-text v-if="itemDetail.customer">
        <v-layout v-if="itemDetail.displayId">
          <span class="subheading">案件編號：{{itemDetail.displayId}}</span>
        </v-layout>
        <v-layout mt-1 v-if="itemDetail.customer.name">
          <span class="subheading">申請人：{{itemDetail.customer.name}}</span>
        </v-layout>
        <v-layout mt-1 v-if="itemDetail.customer.memberId">
          <span class="subheading">身份證：{{itemDetail.customer.memberId}}</span>
        </v-layout>
        <v-layout mt-1>
         <v-flex xs12 md6>
           <v-text-field
             v-model="itemDetail.settingPrice"
             :label="`設定費`"
             placeholder="設定費"
             outline
           ></v-text-field>
         </v-flex>
        </v-layout>
        <v-layout column>
          <span>送件日期</span>
          <date-time-tool :date-info="itemDetail.sendDateInfo"></date-time-tool>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn v-if="showCancel"  class="red" dark text @click="cancelEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark text :loading="saveLoading" :disabled="isSuccess" @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import MobileDetect from 'mobile-detect';
  import dateTimeTool from '../components/dateTimeTool';
  const md = new MobileDetect(window.navigator.userAgent);
  export default {
    name: 'CaseSettingView',
    components:{
      dateTimeTool
    },
    props: {
      itemDetail: Object,
      visible: Boolean,
      showCancel: Boolean,
    },
    data() {
      return {
        isSuccess: false,
        width: md.phone() ? '100%':'70%',
        saveLoading: false,
        messageDialog: {
          visible: false,
          title: '',
          content: '',
        },
        question:'',
        sendDateInfo: {
          year: '',
          month: '',
          day: '',
          isRepublic: true,
          disabled: false,
          startCount: 0,
        },
        sendDate:'',
      }
    },
    watch:{
      visible(value){
        console.log(`setting visible == ${value}`);
        this.checkDefault();
      }
    },
    created() {
      this.question = '';
      this.checkDefault();
    },
    methods:{
      ...mapActions(['saveSettingData', 'saveFinanceCreditData']),
      checkDefault(){
        if (!this.itemDetail.sendDateInfo){
          this.itemDetail.sendDateInfo = this.sendDateInfo;
        }
        if (!this.itemDetail.sendDate){
          this.itemDetail.sendDate = this.sendDate;
        }
        if (!this.itemDetail.settingPrice){
          this.itemDetail.settingPrice = '';
        }
      },
      cancelEvent(){
        this.$emit('cancelEvent');
      },
      async confirmEvent(){
        if (this.itemDetail.settingPrice=== '') {
          this.showDialog(true, '錯誤','請輸入設定費！');
          return;
        }

        if (this.itemDetail.sendDateInfo.isRepublic === true){
          const year = parseInt(this.itemDetail.sendDateInfo.year, 10) + 1911;
          const month = this.itemDetail.sendDateInfo.month;
          const day = this.itemDetail.sendDateInfo.day;
          this.itemDetail.sendDate = `${year}-${month}-${day}`;
        }
        this.saveLoading = true;

        console.log(`saveFinanceCreditData ${JSON.stringify(this.itemDetail)}`);
        const result = await this.saveFinanceCreditData(this.itemDetail);
        console.log(`saveFinanceCreditData result ${JSON.stringify(result)}`);

        const res = await this.saveSettingData({
          caseId: this.itemDetail.caseId,
          settingPrice: this.itemDetail.settingPrice,
          sendDate: this.itemDetail.sendDate,
          sendDateInfo: this.itemDetail.sendDateInfo
        });
        const saveResult = res.data;
        console.log(`save SettingData ${JSON.stringify(saveResult)}`);
        this.saveLoading = false;
        if (saveResult && saveResult.statusCode === 0){
          this.$emit('saveSuccessEvent', saveResult);
        } else {
          this.$emit('saveFailEvent', saveResult);
        }
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CaseStettingView.vue